import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import QRCode from 'react-qr-code'

const APP_STORE_URL = 'https://apps.apple.com/my/app/baseline-tennis-pickleball/id6504704967'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.basenylo.android'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function BaselineAppModal({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-2xl border border-[#042133]/10 bg-white p-6 shadow-[0_30px_80px_-40px_rgba(4,33,51,0.4)]">
        <DialogTitle className="font-semibold text-[#042133] text-lg leading-snug">
          Tải app Baseline để bình chọn
        </DialogTitle>
        <p className="mt-2 text-[#5b7788] text-sm leading-relaxed">
          Mở app Baseline, tìm <strong className="font-semibold text-[#042133]">Vietnam Pickleball Awards</strong> và bình chọn cho đề cử yêu thích của bạn.
        </p>

        {/* QR codes — desktop only */}
        <div className="mt-5 hidden grid-cols-2 gap-4 sm:grid">
          <div className="flex flex-col items-center gap-2">
            <div className="rounded-xl bg-white p-2.5 ring-1 ring-[#042133]/10">
              <QRCode value={APP_STORE_URL} size={100} fgColor="#042133" bgColor="#ffffff" />
            </div>
            <span className="text-[10px] uppercase tracking-[0.15em] text-[#5b7788]">App Store</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="rounded-xl bg-white p-2.5 ring-1 ring-[#042133]/10">
              <QRCode value={PLAY_STORE_URL} size={100} fgColor="#042133" bgColor="#ffffff" />
            </div>
            <span className="text-[10px] uppercase tracking-[0.15em] text-[#5b7788]">Google Play</span>
          </div>
        </div>

        <div className="mt-5 flex flex-col gap-3">
          <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
            <Button className="w-full rounded-full bg-[#042133] text-sm text-white hover:bg-[#042133]/90">
              <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              App Store (iOS)
            </Button>
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
            <Button
              variant="outline"
              className="w-full rounded-full border-[#042133]/30 text-sm text-[#042133] hover:bg-[#042133]/5"
            >
              <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M3.18 23.76c.3.17.64.2.96.09l12.45-7.19-2.73-2.74-10.68 9.84zM.29 1.27C.11 1.6 0 2 0 2.46v19.08c0 .46.11.86.29 1.19l.07.06 10.69-10.69v-.25L.36 1.21l-.07.06zM20.23 10.3l-2.56-1.47-3.05 3.05 3.05 3.05 2.58-1.49c.74-.43.74-1.12-.02-1.14zM3.18.24l12.45 7.19-2.73 2.73L2.22.32C2.53.21 2.87.07 3.18.24z" />
              </svg>
              Google Play (Android)
            </Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  )
}
